module.exports = __webpack_public_path__ + "static/media/screen-twitter-niu.99791eb9.png";